<template>
    <div>
    <div
      class="card"
      v-loading="loading"
      element-loading-text="Cargando..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
    >
        <div class="card px-2 py-3">
            <form @submit.prevent="submit" id="upload" enctype="multipart/form-data" method="post">
            <div class="row">
                <div class="mb-3 col-12 col-md-6">
                  <label for="" class="form-label">Nombres: </label>
                  <input type="text" v-model="form.name" class="form-control">
                </div>
                <div class="mb-3 col-12 col-md-6">
                  <label for="" class="form-label">Apellidos: </label>
                  <input type="text" v-model="form.lastname" class="form-control">
                </div>
                <div class="mb-3 col-12 col-md-6">
                    <label for="" class="form-label">Tipo de documento: </label>
                    <select v-model="form.doc_type_id" class="form-select form-select-lg">
                        <option selected>Select one</option>
                        <option v-for="document_type in document_types" :value="document_type.id" :key="document_type.id">{{document_type.name}}</option>
                    </select>
                </div>
                <div class="mb-3 col-12 col-md-6">
                  <label for="" class="form-label">Nro. de documento: </label>
                  <input type="text"  v-model="form.num_doc" class="form-control" placeholder="">
                </div>
                <div class="mb-3 col-12 col-md-6">
                  <label for="" class="form-label">Nombre del certificado: </label>
                  <input type="text"  v-model="form.name_certificate" class="form-control" placeholder="">
                </div>
                <div class="mb-3 col-12 col-md-6">
                  <label for="" class="form-label">Código del certificado: </label>
                  <input type="text" v-model="form.cod_certificate" class="form-control" placeholder="">
                </div>
                <div class="mb-3 col-12 col-md-6">
                    <el-upload
                        class="picture-card"
                        ref="courseUpload"
                        action=""
                        drag
                        accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                        :on-change="onUploadChange"
                        :http-request="submit"
                        :multiple="false"
                        :limit="1"
                        :auto-upload="false"
                        :file-list="fileList"
                        :on-exceed="handleExceed"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                        Suelta tu archivo aquí o <em>haz clic para cargar</em>
                        </div>
                        <!-- <div slot="tip" class="el-upload__tip">
                        Solo archivos jpg/png con un tamaño menor de 100kb
                        </div> -->
                    </el-upload>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary" :disabled="isSubmitting">Guardar</button>
                </div>
            </div>

            </form>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    props: {
    route: String,
    },
    data() {
        return {
            form: {},
            fileList: [],
            loading: false,
            isSubmitting: false,
        }
    },
    methods: {

        changuePage(){
            window.location.href = this.route;
        },

        async submit(){
            const formdata = new FormData();
            formdata.append('name', this.form.name);
            formdata.append('lastname', this.form.lastname);
            formdata.append('doc_type_id', this.form.doc_type_id);
            formdata.append('num_doc', this.form.num_doc);
            formdata.append('name_certificate', this.form.name_certificate);
            formdata.append('cod_certificate', this.form.cod_certificate);
            formdata.append('img_certificate', this.fileList[0].raw);
            
            try {
                this.loading = true;
                const request = await axios({
                    url: '/clientes-sst/save',
                    method: 'post',
                    data: formdata,
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                const response =
                    request.status == 200
                    ? this.$message.success('El cliente SST ha sido registrado correctamente')
                    : await this.$message.warning('Error al validar datos');
                this.isSubmitting = false;
                this.loading = false;
                this.fileList = [];
                setTimeout(this.changuePage, 2500);
                } catch (error) {
                this.isSubmitting = false;
                this.loading = false;
                console.log(error);
            }
        },

        async getDocumentTypes(){
            await axios.get('/document-types').then((response) => {
                this.document_types = response.data;
            });
        },
        onUploadChange(file) {
            this.fileList = [];

            const isImage =
                file.raw.type === 'image/jpeg' ||
                file.raw.type === 'image/png' ||
                file.raw.type === 'image/jpg';

            // 100kb
            const isLt1M = file.size < 100000;

            if (!isImage) {
                this.$message.error('Solo puede cargar archivos en formato jpg|jpeg|png.');
                this.$refs.courseUpload.clearFiles();
                return false;
            }
            // if (!isLt1M) {
            //     this.$message.error('El archivo no debe pesar más de 100kb!');
            //     this.$refs.courseUpload.clearFiles();
            //     return false;
            // }
            this.fileList.push(file);
            console.log("archivo");
            console.log(this.fileList);
        },
        handleExceed(file) {
            // const isLt1M = file.size > 100000;

            // if (!isLt1M) {
            //     this.$message.error('El archivo no debe pesar más de 100kb!');
            //     this.$refs.courseUpload.clearFiles();
            //     return false;
            // }
        },
    },
    mounted() {
        this.getDocumentTypes();
    },
}
</script>